module.exports = __webpack_public_path__ + "static/gatsby-0165a3347b094bc53d834463d5878997.png";